import { message } from "antd";
import imageUrl from "../../utils/imageUrl";
import styles from "./index.module.less";

const MESSAGE_KEY = "PinPublishSucessMessage";

export const PinPublishSucessMessage = {
  open: ({ pin }: { pin: IPin }) => {
    // @ts-ignore
    message.open({
      key: MESSAGE_KEY,
      className: styles.publishMessage,
      content: (
        <div className={styles.content}>
          <a
            className={styles.img}
            href={`/boards/${pin?.board?.board_id}`}
            target="_blank"
          >
            <img
              src={imageUrl(pin.file, { width: 48 })}
              alt={pin.raw_text || ""}
              height={34}
              width={34}
            />
          </a>
          <div className={styles.info}>你的灵感图已发布!</div>

          <a
            className={styles.button}
            href={`/boards/${pin.board_id}`}
            target="_blank"
          >
            查看
          </a>
        </div>
      ),
    });
  },
};
